module.exports = __webpack_public_path__ + "img/plus-green-icon.da839f78.svg";